/**
 * Qualitative palette (Okabe–Ito–style): evenly separated hues, works for most color-vision deficiencies.
 * Assigned by slice index so adjacent categories stay visually distinct.
 */
export const DISTINCT_PIE_SLICE_COLORS = [
  '#0072B2',
  '#E69F00',
  '#009E73',
  '#CC79A7',
  '#D55E00',
  '#56B4E9',
  '#F0E442',
  '#332288',
  '#117733',
  '#882255',
  '#44AA99',
  '#999933',
  '#AA4499',
  '#661100',
  '#6699CC',
];
